import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormGroupState } from 'ngrx-forms';
import { TeamTaskForm } from '../..';

@Component({
  selector: 'md-team-task-target',
  templateUrl: './team-task-target.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamTaskTargetComponent implements OnInit {
  // @ts-expect-error
  @Input() teamTaskForm: FormGroupState<TeamTaskForm>;

  constructor() {}

  ngOnInit(): void {}
}
